















import { listFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { VozidloPujcovna } from '@/modules/pujcovna/vozidloPujcovna';
import { Zapujcky } from '@/modules/pujcovna/zapujcka';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		VozidloSelect: VozidloPujcovna.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				vozidlo: `${this.storeUri}/${types.mutations.PLANOVANA_PUJCKA_FILTER_VOZIDLO}`,
				zakaznik: `${this.storeUri}/${types.mutations.PLANOVANA_PUJCKA_FILTER_ZAKAZNIK}`,
			};
		},
	},
	methods: {
		processClick(event: any) {
			openEdit(Zapujcky.name, PageMode.CREATE, { planpujcpaId: event.data.ID });
		},
	},
});
